import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Typography } from '@mui/material';
import { setOpenPopup } from '#action/project/devices-popup';
import DevicePopupProject from '#component/device/devices-popup/device-popup-project';
import { ShowMoreContainer } from '#component/project/dashboard/cards/styles';
import ArrowRightButton from '#component/general/arrow-right-button';

const DevicesButton = ({ devicesCount, project, user }) => {
  const dispatch = useDispatch();
  const [openDevicePopup, setOpenDevicePopup] = useState(false);

  const handleOpenDevicePopup = () => {
    setOpenDevicePopup(!openDevicePopup);
    dispatch(setOpenPopup(!openDevicePopup, false));
  };

  if (!devicesCount && !openDevicePopup) {
    return null;
  }

  return (
    <>
      <ShowMoreContainer>
        <Typography color="textSecondary" fontWeight="bold">
          {devicesCount}
        </Typography>
        <ArrowRightButton onClickArrowRight={handleOpenDevicePopup} />
      </ShowMoreContainer>
      {(openDevicePopup) &&
        <DevicePopupProject
          project={project}
          open={openDevicePopup}
          openedFromCreateForm={false}
          handleOpenPopupExternal={setOpenDevicePopup}
          user={user}
        />}
    </>
  );
};

export default DevicesButton;
